/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CompareState } from '@plp/data-access/interfaces';

// Lookup the 'Compare' feature state managed by NgRx
export const selectCompareState = createFeatureSelector<CompareState>('compare');

export const selectCompareBarProducts = createSelector(
  selectCompareState,
  (state) => state.compareBarProducts,
);

export const selectCompareProductDetails = createSelector(
  selectCompareState,
  (state: CompareState) => state.productDetails,
);

export const selectCompareSkeletonLoader = createSelector(
  selectCompareState,
  (state: CompareState) => state.isCompareSkeletonLoaderVisible,
);

export const selectCompareProductDetailsFailed = createSelector(
  selectCompareState,
  (state: CompareState) => state.hasProductDetailsCallFailed,
);

export const selectIsCompareGridOpen = createSelector(
  selectCompareState,
  (state) => state.isCompareGridOpen,
);

export const selectIsCompareHydrated = createSelector(
  selectCompareState,
  (state) => state.isCompareHydrated,
);

export const selectCompareProductsAvailability = createSelector(
  selectCompareState,
  (state) => state.compareProductsAvailability,
);
